import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Lightweight SEO head manager — avoids extra deps while covering title + meta + canonical + JSON-LD. */
export default function Seo({ title, description, canonicalPath, jsonLd, image }) {
  const location = useLocation();
  useEffect(() => {
    const SITE = "LocalDoctor.in";
    const siteUrl = "https://localdoctor.in";
    const finalTitle = title ? `${title} | ${SITE}` : `${SITE} — Doctor chahiye… milega.`;
    const desc =
      description ||
      "Find trusted doctors near you in India. Search by location, specialty or doctor name on LocalDoctor.in.";
    const canonical = `${siteUrl}${canonicalPath || location.pathname}`;

    document.title = finalTitle;

    const upsertMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", finalTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", SITE);
    if (image) upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", finalTitle);
    upsertMeta("name", "twitter:description", desc);
    if (image) upsertMeta("name", "twitter:image", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    // JSON-LD
    const existing = document.getElementById("ld-jsonld");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "ld-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, canonicalPath, jsonLd, image, location.pathname]);

  return null;
}
